import { render, staticRenderFns } from "./shopRecords.vue?vue&type=template&id=2390e651&scoped=true"
import script from "./shopRecords.vue?vue&type=script&lang=js"
export * from "./shopRecords.vue?vue&type=script&lang=js"
import style0 from "./shopRecords.vue?vue&type=style&index=0&id=2390e651&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390e651",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2390e651')) {
      api.createRecord('2390e651', component.options)
    } else {
      api.reload('2390e651', component.options)
    }
    module.hot.accept("./shopRecords.vue?vue&type=template&id=2390e651&scoped=true", function () {
      api.rerender('2390e651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/shopRecords.vue"
export default component.exports